import cx from 'classnames';
import React from 'react';
import { on } from 'tyny/lib/utils/dom/event/on';
import { Spinner } from '../Spinner/Spinner';
import './ui-shortcut.sass';

export interface Props {
  children: React.ReactChild;
  didTrigger?: boolean;
  disabled?: boolean;
  onAction: () => void;
  shortcutKey: string;
  buttonWidth?: number;
}

export function Shortcut({ children, didTrigger, disabled, onAction, shortcutKey, buttonWidth = 1 }: Props) {
  const [isPressed, setPressed] = React.useState(false);

  function onTrigger() {
    if (!disabled) {
      onAction();
    }
  }

  React.useEffect(() => {
    const offs = [
      on(window, 'keyup', (event: KeyboardEvent) => {
        if (event.key === shortcutKey) {
          onTrigger();
          setPressed(false);
        }
      }),
      on(window, 'keydown', (event: KeyboardEvent) => {
        if (!disabled && event.key === shortcutKey) setPressed(true);
      }),
    ];
    return () => offs.forEach((off) => off());
  }, []);

  let symbol = shortcutKey;
  let symbolClass = 'key';
  if (symbol === 'Enter') {
    symbol = '⏎';
    symbolClass = 'plain';
  }

  return (
    <div
      className={cx('dtUiShortcut flex gap-5 items-center w-100', {
        didTrigger,
        disabled,
        isPressed,
      })}
    >
      <div className={cx('dtUiShortcut__child', `flex-${buttonWidth}`, 'font-normal')}>{children}</div>
      {didTrigger ? (
        <div className="dtUiShortcut__hint">
          <Spinner size="small" />
        </div>
      ) : (
        <div className="dtUiShortcut__hint" onClick={onTrigger}>
          {/* <span>oder mit </span> */}
          <span className={symbolClass}>{symbol}</span>
        </div>
      )}
    </div>
  );
}
